export default function authHeader() {
     let user = (localStorage.getItem('jwt'));
     if (user) {
       return { Authorization: 'Bearer ' + user };
     } else {
       return {};
     }
  }
  
